import ModalContainer from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('redeem_manager.modifier_select')

type ItemsModalProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  items: string[]
}

const ItemsModal = ({ isOpen, onClose, title, items }: ItemsModalProps) => {
  const [css] = useStyletron()

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      showBottomProceed={false}
      hideCancel
      title={title}
    >
      <div className="d-flex flex-column">
        <p className="body-text-4 grey-70 mb-s">
          {t('items_in_modifier_modal_subtitle')}
        </p>
        <ul
          className={`list-style-type-disc pl-m grey-70 ${css({
            maxHeight: '400px',
            overflowY: 'auto',
          })}`}
        >
          {items.map(item => (
            <li className="mb-xs" key={item}>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </ModalContainer>
  )
}

export default ItemsModal
